import React, { useState } from 'react';
import { File, FileText, FolderOpen, Clock, Calendar, Filter, Search, ChevronDown, Plus, Download } from 'lucide-react';
import { DepartmentSelector } from './DepartmentSelector';
import { DocumentViewer } from './DocumentViewer';
import { DocumentUploadModal } from './DocumentUploadModal';
export const DocumentManagement = ({
  activeDepartment,
  setActiveDepartment
}) => {
  const [activeTab, setActiveTab] = useState('all');
  const [viewMode, setViewMode] = useState('grid');
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const openDocumentViewer = document => {
    setSelectedDocument(document);
  };
  const closeDocumentViewer = () => {
    setSelectedDocument(null);
  };
  return <div className="p-6" data-id="element-219">
      <div className="flex justify-between items-center mb-6" data-id="element-220">
        <div className="flex items-center space-x-4" data-id="element-221">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-222">Documents</h1>
          <DepartmentSelector activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-223" />
        </div>
        <div className="flex items-center space-x-3" data-id="element-224">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center space-x-2 hover:bg-blue-700 transition-colors" onClick={() => setIsUploadModalOpen(true)} data-id="element-225">
            <Plus className="h-4 w-4" data-id="element-226" />
            <span data-id="element-227">New Document</span>
          </button>
          <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-228">
            <button className={`px-3 py-2 ${viewMode === 'grid' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setViewMode('grid')} data-id="element-229">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-230">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" data-id="element-231" />
              </svg>
            </button>
            <button className={`px-3 py-2 ${viewMode === 'list' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setViewMode('list')} data-id="element-232">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-233">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-234" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="flex items-center space-x-6 border-b border-gray-200 mb-6" data-id="element-235">
        <button className={`py-3 px-1 ${activeTab === 'all' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('all')} data-id="element-236">
          All Documents
        </button>
        <button className={`py-3 px-1 ${activeTab === 'recent' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('recent')} data-id="element-237">
          Recent
        </button>
        <button className={`py-3 px-1 ${activeTab === 'archived' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('archived')} data-id="element-238">
          Archived
        </button>
        <button className={`py-3 px-1 ${activeTab === 'favorites' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('favorites')} data-id="element-239">
          Favorites
        </button>
      </div>
      <div className="flex justify-between items-center mb-6" data-id="element-240">
        <div className="relative w-96" data-id="element-241">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" data-id="element-242" />
          <input type="text" placeholder="Search documents..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full" data-id="element-243" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-244">
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-245">
            <Filter className="h-4 w-4" data-id="element-246" />
            <span data-id="element-247">Filters</span>
            <ChevronDown className="h-4 w-4" data-id="element-248" />
          </button>
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-249">
            <Clock className="h-4 w-4" data-id="element-250" />
            <span data-id="element-251">Last modified</span>
            <ChevronDown className="h-4 w-4" data-id="element-252" />
          </button>
        </div>
      </div>
      {viewMode === 'grid' ? <div className="grid grid-cols-4 gap-6" data-id="element-253">
          {documents.filter(doc => {
        if (activeTab === 'all') return true;
        if (activeTab === 'archived') return doc.status === 'Archived';
        if (activeTab === 'recent') return ['Today, 10:30 AM', 'Yesterday'].includes(doc.modified);
        return false;
      }).map(doc => <div key={doc.id} onClick={() => openDocumentViewer(doc)} className="cursor-pointer" data-id="element-254">
                <DocumentCard document={doc} data-id="element-255" />
              </div>)}
        </div> : <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-256">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-257">
            <thead className="bg-gray-50" data-id="element-258">
              <tr data-id="element-259">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-260">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-261">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-262">
                  Date Modified
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-263">
                  Size
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-264">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-265">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-266">
              {documents.filter(doc => {
            if (activeTab === 'all') return true;
            if (activeTab === 'archived') return doc.status === 'Archived';
            if (activeTab === 'recent') return ['Today, 10:30 AM', 'Yesterday'].includes(doc.modified);
            return false;
          }).map(doc => <tr key={doc.id} className="hover:bg-gray-50" data-id="element-267">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-268">
                      <div className="flex items-center" data-id="element-269">
                        <div className="flex-shrink-0 h-10 w-10 bg-gray-100 rounded-md flex items-center justify-center" data-id="element-270">
                          {getDocumentIcon(doc.type)}
                        </div>
                        <div className="ml-4" data-id="element-271">
                          <div className="text-sm font-medium text-gray-900 cursor-pointer hover:text-blue-600" onClick={() => openDocumentViewer(doc)} data-id="element-272">
                            {doc.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-273">
                      {doc.type}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-274">
                      {doc.modified}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-275">
                      {doc.size}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-276">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(doc.status)}`} data-id="element-277">
                        {doc.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-278">
                      <button className="text-blue-600 hover:text-blue-900 mr-3" onClick={() => openDocumentViewer(doc)} data-id="element-279">
                        View
                      </button>
                      <button className="text-gray-600 hover:text-gray-900" data-id="element-280">
                        <Download className="h-4 w-4" data-id="element-281" />
                      </button>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>}
      {/* Document Viewer Modal */}
      {selectedDocument && <DocumentViewer document={selectedDocument} onClose={closeDocumentViewer} data-id="element-282" />}
      {/* Document Upload Modal */}
      <DocumentUploadModal isOpen={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} activeDepartment={activeDepartment} data-id="element-283" />
    </div>;
};
const DocumentCard = ({
  document
}) => {
  return <div className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-284">
      <div className="h-32 bg-gray-100 flex items-center justify-center" data-id="element-285">
        {getDocumentIcon(document.type, 'h-16 w-16 text-gray-400')}
      </div>
      <div className="p-4" data-id="element-286">
        <h3 className="font-medium text-gray-800 mb-1 truncate" data-id="element-287">
          {document.name}
        </h3>
        <div className="flex justify-between items-center" data-id="element-288">
          <span className="text-xs text-gray-500" data-id="element-289">{document.modified}</span>
          <span className={`px-2 py-1 text-xs rounded-full ${getStatusColor(document.status)}`} data-id="element-290">
            {document.status}
          </span>
        </div>
      </div>
    </div>;
};
const getDocumentIcon = (type, className = 'h-6 w-6 text-gray-500') => {
  switch (type) {
    case 'PDF':
      return <FileText className={className} data-id="element-291" />;
    case 'Folder':
      return <FolderOpen className={className} data-id="element-292" />;
    case 'Document':
      return <File className={className} data-id="element-293" />;
    default:
      return <File className={className} data-id="element-294" />;
  }
};
const getStatusColor = status => {
  switch (status) {
    case 'Active':
      return 'bg-green-100 text-green-800';
    case 'Archived':
      return 'bg-gray-100 text-gray-800';
    case 'Draft':
      return 'bg-yellow-100 text-yellow-800';
    case 'Pending':
      return 'bg-blue-100 text-blue-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
// Sample data
const documents = [{
  id: 1,
  name: 'Annual Report 2023.pdf',
  type: 'PDF',
  modified: 'Today, 10:30 AM',
  size: '2.4 MB',
  status: 'Active'
}, {
  id: 2,
  name: 'Employee Handbook',
  type: 'Document',
  modified: 'Yesterday',
  size: '1.8 MB',
  status: 'Active'
}, {
  id: 3,
  name: 'Financial Documents',
  type: 'Folder',
  modified: 'Aug 15, 2023',
  size: '45 MB',
  status: 'Active'
}, {
  id: 4,
  name: 'Marketing Strategy.pdf',
  type: 'PDF',
  modified: 'Aug 10, 2023',
  size: '3.2 MB',
  status: 'Draft'
}, {
  id: 5,
  name: 'Project Proposal.pdf',
  type: 'PDF',
  modified: 'Jul 28, 2023',
  size: '1.5 MB',
  status: 'Pending'
}, {
  id: 6,
  name: 'Meeting Minutes',
  type: 'Document',
  modified: 'Jul 22, 2023',
  size: '0.8 MB',
  status: 'Active'
}, {
  id: 7,
  name: 'Budget 2022.pdf',
  type: 'PDF',
  modified: 'Jun 15, 2023',
  size: '4.1 MB',
  status: 'Archived'
}, {
  id: 8,
  name: 'Legal Contracts',
  type: 'Folder',
  modified: 'Jun 10, 2023',
  size: '28 MB',
  status: 'Active'
}];